import { UniqueEntityId } from "@kernel/ddd";
import { Participant, ParticipantProps } from "./Participant";
import { Peer } from "domain/peer";
import { Stream } from "domain/stream";

export function isRemoteParticipant(
  participant: Participant
): participant is RemoteParticipant {
  return participant.isLocal() === false;
}
export interface RemoteParticipantProps extends ParticipantProps {
  peer: Peer;
}
export class RemoteParticipant extends Participant<RemoteParticipantProps> {
  private disabledTransceiversMid: Map<string, string | null> = new Map(
    Object.entries({ audio: null, video: null })
  );

  public get peer(): Peer {
    return this.props.peer;
  }

  public set peer(peer: Peer) {
    this.props.peer = peer;
  }

  public disableTransceiver(type: "audio" | "video", stream: Stream): void {
    const track = stream.getTracks().find((t) => t.kind == type);
    if (!track) return;
    const transceiver = this.peer
      .getTransceivers()
      .find(
        (t) =>
          t.direction === "sendonly" &&
          t.sender.track !== null &&
          t.sender.track.kind == type
      );
    if (!transceiver) return;
    setTimeout(() => {
      transceiver.sender.replaceTrack(null);
    }, 100);
    this.disabledTransceiversMid.set(type, transceiver.mid);
  }

  public enableTransceiver(type: "audio" | "video", stream: Stream): void {
    const track = stream.getTracks().find((t) => t.kind == type);
    if (!track) return;
    const mid = this.disabledTransceiversMid.get(type);
    if (!mid) return;
    const transceiver = this.peer.getTransceivers().find((t) => t.mid === mid);
    if (!transceiver) return;
    setTimeout(() => {
      transceiver.sender.replaceTrack(track);
    }, 100);
    this.disabledTransceiversMid.set(type, null);
  }

  public clone(): RemoteParticipant {
    return new RemoteParticipant(
      { ...this.props },
      new UniqueEntityId(this.id.toValue())
    );
  }

  public isLocal(): boolean {
    return false;
  }

  public static create(
    props: RemoteParticipantProps,
    id?: UniqueEntityId
  ): RemoteParticipant {
    const defaultValues: RemoteParticipantProps = {
      ...props,
      stream: props.stream
    };
    return new RemoteParticipant(defaultValues, id);
  }
}
